export function RouteFallback() {
  return (
    <div role="status" aria-live="polite" className="flex min-h-[60vh] items-center justify-center">
      <div className="border-earth-300 border-t-earth-800 h-8 w-8 animate-spin rounded-full border-2 motion-reduce:animate-none" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
